import Search from '@/containers/trainer_apply/Search';
import CoachNotExists from '@/containers/trainer_apply/CoachNotExists';
import CoachNotVisited from '@/containers/trainer_apply/CoachNotVisited';
import QRCode from '@/containers/trainer_apply/QRCode';

import { ROUTE_TRAINER_APPLY_SEARCH, ROUTE_TRAINER_APPLY_COACH_MISSING, ROUTE_TRAINER_APPLY_COACH_SEPARATED, ROUTE_TRAINER_APPLY_QRCODE } from '@/router/names';
import { SCOPE_SNSAPI_USERINFO } from '@/constants/wechat';

export default [
    {
        path: '/trainer_apply/search',
        name: ROUTE_TRAINER_APPLY_SEARCH,
        component: Search,
        meta: {
            wechat_auth: SCOPE_SNSAPI_USERINFO,
            title: '绑定教练',
        },
    },
    {
        path: '/trainer_apply/:phone/missing',
        name: ROUTE_TRAINER_APPLY_COACH_MISSING,
        component: CoachNotExists,
        meta: {
            wechat_auth: SCOPE_SNSAPI_USERINFO,
            title: '教练查找失败',
        },
    },
    {
        path: '/trainer_apply/:phone/separated',
        name: ROUTE_TRAINER_APPLY_COACH_SEPARATED,
        component: CoachNotVisited,
        meta: {
            wechat_auth: SCOPE_SNSAPI_USERINFO,
            title: '教练查找失败',
        },
    },
    {
        path: '/trainer_apply/:id(\\d+)/qrcode',
        name: ROUTE_TRAINER_APPLY_QRCODE,
        component: QRCode,
        meta: {
            wechat_auth: SCOPE_SNSAPI_USERINFO,
            title: '绑定教练',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/trainer_apply.js